<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-2 py-1 px-4" dense height="30">
      <v-toolbar-title>{{ $t(type) }}</v-toolbar-title>
      <!--      <v-radio-group-->
      <!--        v-model="type"-->
      <!--        class="mt-6"-->
      <!--        row-->
      <!--      >-->
      <!--        <v-radio-->
      <!--          :label="$t('formula')"-->
      <!--          value="formula"-->
      <!--        />-->
      <!--        <v-radio-->
      <!--          :label="$t('production')"-->
      <!--          value="production"-->
      <!--        />-->
      <!--      </v-radio-group>-->
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f2']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="addRow()"
            v-on="on"
            @click="addRow()"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("newRow") }} (f2)</span>
      </v-tooltip>
      <v-tooltip v-if="selected.length > 0" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="deletDialog = true"
          >
            <v-icon color="pink" style="font-size: 22px"> mdi-trash-can-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("remove") }}</span>
      </v-tooltip>
      <!--      <v-tooltip bottom>-->
      <!--        <template v-slot:activator="{ on, attrs }">-->
      <!--          <v-btn-->
      <!--            v-bind="attrs"-->
      <!--            icon-->
      <!--            small-->
      <!--            class="float-left"-->
      <!--            v-on="on"-->
      <!--            @click="showSelect = !showSelect"-->
      <!--          >-->
      <!--            <v-icon-->
      <!--              color="blue"-->
      <!--              style="font-size: 22px"-->
      <!--            >-->
      <!--              {{ (showSelect ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked-outline') }}-->
      <!--            </v-icon>-->
      <!--          </v-btn>-->
      <!--        </template>-->
      <!--        <span>{{ $t('select-row') }}</span>-->
      <!--      </v-tooltip>-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo(type + 'List')"
          >
            <v-icon color="primary" style="font-size: 22px">
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("list") }} {{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon color="primary" style="font-size: 22px"> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("back") }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form v-if="render" ref="form" v-model="valid" lazy-validation>
      <v-row class="mx-0 my-2">
        <v-col
          v-if="type == 'formula'"
          class="mb-0 pb-0"
          cols="12"
          md="3"
          sm="3"
          style="height: 55px"
        >
          <v-text-field
            v-model="name"
            :label="$t('name')"
            height="20"
            dense
            :rules="[(v) => !!v || $t('is-required')]"
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-col v-if="type == 'production'" cols="12" md="3" sm="3">
          <autocomplete v-model="formula" title="formula" type="productionFormula" />
        </v-col>
        <!--        <v-col-->
        <!--          v-if="type == 'production'"-->
        <!--          class="mb-0 pb-0 "-->
        <!--          cols="12"-->
        <!--          md="3"-->
        <!--          sm="3"-->
        <!--          style="height: 55px"-->
        <!--        >-->
        <!--          <v-text-field-->
        <!--            v-model="number"-->
        <!--            :label="$t('number')"-->
        <!--            height="20"-->
        <!--            dense-->
        <!--            :rules="[v => !!v || $t('is-required')]"-->
        <!--            outlined-->
        <!--            class="mb-1 dense"-->
        <!--            clearable-->
        <!--            @blur="getProductionNumber"-->
        <!--          />-->
        <!--        </v-col>-->
        <v-col class="mb-0 pb-0" cols="12" md="3" sm="3" style="height: 55px">
          <autocomplete
            ref="refProduct"
            v-model="product"
            :rules="[(v) => !!v || $t('is-required')]"
            :title="$t('product')"
            type="product"
            :serial-btn="showSerialFeature && getProductHasSerial(product)"
            @serial-click="openHeaderSerialDialog"
          />
        </v-col>
        <v-col
          v-show="type !== 'bundling'"
          class="mb-0 pb-0"
          cols="12"
          md="3"
          sm="3"
          style="height: 55px"
        >
          <v-text-field
            v-model="count"
            :label="$t('count')"
            height="20"
            dense
            type="number"
            :rules="[(v) => !!v || $t('is-required')]"
            outlined
            :disabled="type == 'production' ? false : false"
            class="mb-1 dense"
          />
        </v-col>
        <v-col
          v-show="type !== 'bundling'"
          class="mb-0 pb-0"
          cols="12"
          md="3"
          sm="3"
          style="height: 55px"
        >
          <money
            v-model="amount"
            :label="$t('amountOfUnit') + '(~)'"
            :dense="true"
            :outlined="true"
            :solo="false"
            :clearable="true"
            value-when-is-empty=""
            :options="options"
            class="mb-3 dense"
          />
        </v-col>
        <v-col v-show="type !== 'bundling'" cols="12" md="3" sm="3">
          <autocomplete
            ref="refEntrepot"
            v-model="entrepot"
            title="entrepot"
            type="entrepot"
            :set-init="id ? (!entrepot ? true : false) : true"
            :new-btn="true"
            :value="entrepot"
          />
        </v-col>
        <v-col v-if="type == 'production'" cols="12" md="3" sm="3">
          <template>
            <v-text-field
              id="from"
              v-model="date"
              :label="$t('date')"
              :rules="[(v) => !!v || $t('is-required')]"
              clear-icon="flaticon2-close-cross"
              outlined
              dense
              clearable
            />

            <date-picker
              v-model="date"
              element="from"
              :locale="$store.state.date_locale"
              :format="$store.state.date_format"
              auto-submit
              :min="$store.state.startDate"
              :max="$store.state.endDate"
              :color="
                this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light']
                  .primary
              "
              @close="setDate"
            />
          </template>
        </v-col>
        <v-col v-if="type == 'production'" cols="12" md="3">
          <autocomplete
            v-model="branch"
            :title="$t('branch')"
            type="branch"
            :set-init="true"
            :value="branch"
          />
        </v-col>
        <v-col
          v-if="type == 'production'"
          class="mb-0 pb-0"
          cols="12"
          md="3"
          sm="3"
          style="height: 55px"
        >
          <status v-model="status" :hideconfig="true" :type="type" :value="status" />
        </v-col>
        <v-col v-if="type == 'production'" cols="12" md="3">
          <tag v-model="tag" :solo="false" :input="tag" :height="25" />
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col v-if="type == 'production'" cols="12" md="6">
          <v-textarea :label="$t('description')" v-model="content" outlined rows="3" />
        </v-col>
      </v-row>
      <v-tabs>
        <v-tab>{{ $t("usedGoods") }}</v-tab>
        <v-tab-item>
          <v-container>
            <v-row>
              <v-col cols="12" class="px-2 py-0 mt-2">
                <v-data-table
                  v-if="headers"
                  :height="tableHeight"
                  fixed-header
                  v-model="selected"
                  :headers="headers"
                  :items="items"
                  :options.sync="tableOptions"
                  :server-items-length="totalItems"
                  :loading="loading"
                  multi-sort
                  dense
                  :show-select="showSelect"
                  hide-default-footer
                  item-key="id"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item
                          v-if="item.product && costManagament"
                          link
                          @click="openCostDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon> mdi-cash-minus </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('cost')" />
                        </v-list-item>
                        <v-list-item
                          v-if="costManagament"
                          link
                          @click="openCostListDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon> mdi-format-list-bulleted-square </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('costs')" />
                        </v-list-item>
                        <v-list-item link @click="openDeleteDialog(item)">
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                  <template v-slot:item.row="{ item }">
                    {{ parseInt(items.indexOf(item)) + parseInt(from) }}
                  </template>
                  <template v-slot:item.product="{ item }">
                    <autocomplete
                      :ref="'refProduct' + parseInt(items.indexOf(item))"
                      v-model="item.product"
                      :value="item.product"
                      class="mb-3"
                      :rules="[(v) => !!v || $t('is-required')]"
                      type="productService"
                      :data="JSON.stringify({ entrepot: entrepot ? entrepot.id : null })"
                      :new-btn="true"
                      :serial-btn="showSerialFeature && rowHasSerial(item)"
                      @input="checkProduct(item.product, parseInt(items.indexOf(item)))"
                      @serial-click="openSerialDialog(item)"
                    />
                  </template>
                  <template v-slot:item.unit="{ item }">
                    {{ item.product && item.product.unit ? item.product.unit.fame : "" }}
                  </template>
                  <template v-slot:item.stock="{ item }">
                    {{
                      item.product && item.product.stock
                        ? $numberFormat(item.product.stock.count)
                        : 0
                    }}
                    <!--                    <v-tooltip bottom>-->
                    <!--                      <template v-slot:activator="{ on, attrs }">-->
                    <!--                        <v-badge-->
                    <!--                          color="error"-->
                    <!--                          overlap-->
                    <!--                          :content="item.cost.length"-->
                    <!--                          :value="item.cost.length"-->
                    <!--                        >-->
                    <!--                          <v-btn-->
                    <!--                            v-if="item.cost.length > 0"-->
                    <!--                            v-bind="attrs"-->
                    <!--                            color="cyan"-->
                    <!--                            x-small-->
                    <!--                            class="mx-1"-->
                    <!--                            v-on="on"-->
                    <!--                            @click="openCostListDialog(item)"-->
                    <!--                          >-->
                    <!--                            {{ $t('costs') }}-->
                    <!--                          </v-btn>-->
                    <!--                        </v-badge>-->
                    <!--                      </template>-->
                    <!--                      <span>{{ $t('cost') }}</span>-->
                    <!--                    </v-tooltip>-->
                  </template>
                  <template v-slot:item.count="{ item }">
                    <v-text-field
                      v-model="item.count"
                      height="20"
                      dense
                      solo
                      flat
                      class="mb-3 dense"
                      clearable
                      :background-color="$vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5'"
                      :placeholder="$t('count')"
                      type="number"
                      @input="getCost(item)"
                    />
                  </template>
                  <template v-slot:item.fee="{ item }">
                    <money
                      v-model="item.fee"
                      :dense="true"
                      :outlined="true"
                      :disabled="type == 'production' || type == 'formula' ? false : true"
                      :solo="false"
                      :clearable="true"
                      value-when-is-empty=""
                      :options="options"
                      class="mb-3 dense"
                    />
                  </template>
                  <template v-slot:item.sum="{ item }">
                    {{
                      $numberFormat(
                        (parseFloat(item.fee) * parseFloat(item.count)).toFixed(
                          $store.state.currency.decimal
                        )
                      )
                    }}
                  </template>
                  <template v-slot:item.content="{ item }">
                    <v-text-field
                      v-model="item.content"
                      height="20"
                      dense
                      solo
                      flat
                      class="mb-3 dense"
                      :background-color="$vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5'"
                      clearable
                      :placeholder="$t('content')"
                    />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs>
      <v-divider class="mx-2" />
      <v-card-actions class="pt-0">
        <v-row class="ma-0">
          <v-col cols="6" class="px-0">
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t("submit") }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t("submit") }}
            </v-btn>
          </v-col>
          <v-col cols="6" class="px-2">
            <v-btn color="grey" outlined class="float-left" @click="goTo(type + 'List')">
              {{ $t("backToList") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-row />
    </v-form>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="costDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="costDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("cost") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <cost type="cost" :ref-id="selectedItem" @input="setCost" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="costListDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="costListDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("costs") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      {{ $t("number") }}
                    </th>
                    <th>
                      {{ $t("cost") }}
                    </th>
                    <th>
                      {{ $t("amount") }}
                    </th>
                    <th>
                      {{ $t("actions") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in costItems.cost" :key="item.id">
                    <td>{{ Number(i) + 1 }}</td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ $numberFormat(item.amount) }}</td>
                    <td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            color="pink"
                            x-small
                            icon
                            v-on="on"
                            @click="remoceCostList(item)"
                          >
                            <v-icon small> mdi-trash-can-outline </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("remove") }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6"> </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
    <serial-management-dialog
      v-if="showSerialFeature"
      v-model="serialDialog"
      :product="(serialItem && serialItem.product) || {}"
      :entrepot="entrepot || {}"
      :total-count="serialItem && serialItem.count"
      :serials="serialDialogList"
      :serial-flow="serialFlow"
      :loading="serialsLoading"
      :has-more="serialHasMore"
      :selected-serials="(serialItem && serialItem.serials) || []"
      @confirm="setSerials"
      @search="onSerialSearch"
      @load-more="loadMoreSerials"
    />
  </v-card>
</template>

<script>
import Task from "../task/task";
import Cost from "../cost&income/cost";
import General from "../../../../Mixins/general";
import SerialManagementDialog from "../../components/general/serials/SerialManagementDialog";
export default {
  name: "SellList",
  components: {
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Task,
    Cost,
    SerialManagementDialog,
  },
  mixins: [General],
  props: ["input", "formType", "refId"],
  data: () => ({
    selected: [],
    costDialog: false,
    formula: null,
    costManagament: null,
    count: 1,
    number: 1,
    name: null,
    costItems: null,
    product: null,
    selectedItem: null,
    printDialog: false,
    costListDialog: false,
    deletDialog: false,
    showSelect: false,
    render: false,
    filter: false,
    valid: true,
    detail: null,
    recipientEntrepot: null,
    relations: null,
    productStatus: null,
    productStatusItems: null,
    date: null,
    entrepot: null,
    model: null,
    from: 1,
    taskDialog: null,
    id: null,
    status: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 1000,
    isLoading: false,
    snakbar: false,
    type: "receipt",
    taskId: null,
    checkNumber: false,
    snakbarText: null,
    loading: true,
    tableOptions: {
      itemsPerPage: 1000,
    },
    headers: null,
    search: null,
    content: null,
    serialDialog: false,
    serialsLoading: false,
    serialPage: 1,
    serialLastPage: 1,
    serialSearch: "",
    serialCancelToken: null,
    serialRequestId: 0,
    serialItem: null,
    serialFlowMode: "out",
    headerSerialRow: {
      product: null,
      count: 1,
      serials: [],
      has_serial: "deactive",
    },
  }),
  computed: {
    showSerialFeature() {
      return this.type !== "formula";
    },
    serialFlow() {
      return this.serialFlowMode;
    },
    serialDialogList() {
      if (!this.serialItem) return [];
      if (this.serialFlow === "out") {
        return this.serialItem.serialOptions || [];
      }
      return this.serialItem.serials || [];
    },
    serialHasMore() {
      return this.serialFlow === "out" && this.serialPage < this.serialLastPage;
    },
    amount: function () {
      var sum = 0;
      this.items.map(function (value, key) {
        sum = parseFloat(sum) + parseFloat(value.fee) * parseFloat(value.count);
      });
      sum = this.toDecimal(sum) / this.count;
      sum = Number(parseFloat(sum).toFixed(0));
      return sum;
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      // this.getItems()
    },
    formula() {
      if (this.formula && !this.id) {
        this.setFormula();
      } else {
      }
    },
    product(val, oldVal) {
      this.headerSerialRow.product = this.product;
      this.headerSerialRow.count = this.count;
      if (this.id && !oldVal) return;
      this.syncRowSerialFlag(this.headerSerialRow);
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        // app.getItems()
      }, 1000);
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.tableOptions.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    count(val, oldVal) {
      this.headerSerialRow.count = val;
      if (val < 1) {
        return false;
      }
      if (this.render) {
        this.items.map(function (value) {
          // var rate = value.count / (oldVal < 1 ? 1 : oldVal)
          value.countRate =
            value.countRate != undefined && value.countRate == null
              ? value.count
              : value.countRate;
          value.count = value.countRate * val;
        });
      }
      this.render = true;
    },
    relations() {
      var app = this;
      if (app.relations && app.relations.article && !app.id) {
        app.items = [];
        app.items = app.relations.article;
        app.items.map(function (value, key) {
          value.cost = [];
        });
        app.items.forEach((item) => {
          if (!item.serials) app.$set(item, "serials", []);
          app.hydrateItemSerials(item);
        });
      } else {
        app.addRow();
      }
    },
  },
  beforeMount() {
    var storage = JSON.parse(localStorage.getItem("token"));
    this.costManagament = storage.init.goodCostManagement.value;
    this.type = this.$route.name;
    if (this.$route.params.id != null) {
      this.render = false;
      this.id = this.$route.params.id;
      this.show();
    } else {
      this.render = true;
      this.getProductionNumber();
      this.addRow();
    }
  },
  mounted() {
    this.headers = [
      {
        text: this.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("product"),
        sortable: true,
        value: "product",
      },
      {
        text: this.$t("unit"),
        sortable: true,
        value: "unit",
      },
      {
        text: this.$t("stock"),
        sortable: true,
        value: "stock",
        align: this.type === "bundling" ? " d-none" : "center",
      },
      {
        text: this.$t("count"),
        sortable: true,
        value: "count",
      },
      {
        text: this.$t("fee"),
        sortable: true,
        value: "fee",
        align: this.type === "bundling" ? " d-none" : "center",
      },
      {
        text: this.$t("sum") + "(~)",
        sortable: true,
        value: "sum",
        align: this.type === "bundling" ? " d-none" : "center",
      },
      {
        text: this.$t("content"),
        sortable: false,
        value: "content",
        align: this.type === "bundling" ? " d-none" : "center",
      },
    ];
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.loading = false;
  },
  beforeDestroy() {
    if (this.serialCancelToken) {
      this.serialCancelToken.cancel("Canceled due to destroy");
    }
  },
  methods: {
    getProductionNumber() {
      if (this.type === "formula" || this.type === "bundling") {
        return false;
      }
      this.loading = true;
      var app = this;
      app.isLoading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              type: app.type,
              id: app.id,
              number: app.number,
              select: "getProductionNumber",
            },
          })
          .then((res) => {
            res = res.data;
            if (res.status === "error") {
              if (app.checkNumber) {
                app.snakbarText = res.message;
                app.snakbarColor = "pink";
                app.snakbar = true;
              }
              app.number = res.number;
            }
            app.checkNumber = true;
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }, 50);
      // setTimeout(() => {
      //   app.$refs.autocomplete.onScroll()
      // }, 1500)
      this.loading = false;
    },
    setFormula() {
      this.items = this.formula.article;
      this.entrepot = this.formula.entrepot;
      this.product = this.formula.product;
      (this.items || []).forEach((item) => {
        if (!item.serials) this.$set(item, "serials", []);
        this.hydrateItemSerials(item);
      });
    },
    openCostListDialog(item) {
      this.costItems = item;
      this.costListDialog = true;
    },
    openCostDialog(item) {
      this.selectedItem = item;
      this.costDialog = true;
    },
    setCost(val) {
      var index = this.items.indexOf(this.selectedItem);
      this.items[index].cost.push(val);
      this.costDialog = false;
      this.selectedItem = null;
    },
    getCost(item) {
      if (!item.product || !this.entrepot) return;
      if (item.product.type === "service") return;
      if (item.product && this.entrepot) {
        var app = this;
        app.isLoading = true;
        app.$axios
          .get(this.$endpoint + "getdetail", {
            params: {
              select: "getGoodCost",
              productId: item.product ? item.product.id : null,
              entrepotId: app.entrepot ? app.entrepot.id : null,
              count: item.count,
            },
          })
          .then((res) => {
            res = res.data;
            item.fee = Number(
              parseFloat(res.cost.sumPrice / res.cost.countCalculated).toFixed(0)
            );
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }
    },
    addRow() {
      this.items.push({
        product: null,
        unit: null,
        cost: [],
        stock: null,
        count: null,
        fee: null,
        sum: null,
        content: null,
        serials: [],
      });
    },
    remove(item, index1) {
      var index = this.items.indexOf(this.deleteItem);
      var cost = this.deleteItem.cost;
      this.items.splice(index, 1);
      this.deletDialog = false;
      if (cost.length > 0) {
        this.removeCost(cost);
      }
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: "ProductEdit", params: { id: item.id } });
    },
    checkProduct(item, key) {
      this.syncRowSerialFlag(this.items[key]);
      if (item) {
        var index = this.items.findIndex((x) => x.product.id === item.id);
        if (index !== key) {
          this.$refs["refProduct" + key].clear();
          this.snakbarText = this.$t("alert-product-is-repetitive");
          this.snakbarColor = "pink";
          this.snakbar = true;
        }
      } else {
        this.removeCost(this.items[key].cost);
        this.items[key].cost = [];
      }
    },
    checkCount(item) {
      if (
        this.$store.state.negative_inventory === "no" &&
        this.type === "remittance" &&
        parseFloat(item.count) > parseFloat(item.product.stock.count)
      ) {
        this.snakbarText = this.$t("alert-inventory-is-not-enough");
        this.snakbarColor = "pink";
        this.snakbar = true;
        item.count = 0;
      }
    },
    removegroup() {
      var app = this;
      app.selected.map(function (value, key) {
        app.remove(value, key);
      });
    },
    getProductHasSerial(product) {
      if (!product) return false;
      const flag = (product.meta && product.meta.has_serial) || product.has_serial;
      return flag === "active";
    },
    rowHasSerial(item) {
      return !!(
        item &&
        (item.has_serial === "active" || this.getProductHasSerial(item.product))
      );
    },
    syncRowSerialFlag(item) {
      if (!item) return;
      const productId = item.product && item.product.id;
      if (this.getProductHasSerial(item.product)) {
        this.$set(item, "has_serial", "active");
        item._serialProductId = productId;
        return;
      }
      if (productId && productId === item._serialProductId) return;
      this.$set(item, "has_serial", "deactive");
      item.serials = [];
      item._serialProductId = productId || null;
    },
    normalizeArticleSerials(source) {
      return (source || [])
        .map((serial, index) => {
          const raw =
            typeof serial === "string"
              ? serial
              : serial &&
                (serial.value ||
                  serial.serial ||
                  serial.serial_number ||
                  serial.code ||
                  "");
          const value = String(raw || "").trim();
          if (!value) return null;
          return {
            id: (serial && (serial.id || serial.serial_id)) || null,
            uid: (serial && (serial.uid || serial.id)) || `${value}-${index}`,
            value,
            created_at: (serial && (serial.created_at || serial.createdAt)) || "",
            selected: serial && serial.selected !== undefined ? !!serial.selected : true,
          };
        })
        .filter(Boolean);
    },
    hydrateItemSerials(item) {
      if (!item || !item.product) return;
      if (this.getProductHasSerial(item.product)) {
        this.$set(item, "has_serial", "active");
        item._serialProductId = item.product.id;
      }
      if (item.serials && item.serials.length) return;
      this.$set(item, "serials", this.normalizeArticleSerials(item.product.serials));
    },
    openSerialDialog(item, flow = "out") {
      this.serialFlowMode = flow;
      if (flow === "out") {
        this.hydrateItemSerials(item);
      } else if (this.getProductHasSerial(item.product)) {
        this.$set(item, "has_serial", "active");
        item._serialProductId = item.product && item.product.id;
      }
      if (!item.serials) item.serials = [];
      this.serialItem = item;
      this.serialDialog = true;
      if (flow === "out") {
        this.serialPage = 1;
        this.serialLastPage = 1;
        this.serialSearch = "";
        this.$set(item, "serialOptions", []);
        this.fetchProductSerials(item, { page: 1, search: "", append: false });
      }
    },
    openHeaderSerialDialog() {
      this.headerSerialRow.product = this.product;
      this.headerSerialRow.count = this.count;
      if (!this.headerSerialRow.serials) this.headerSerialRow.serials = [];
      this.openSerialDialog(this.headerSerialRow, "in");
    },
    onSerialSearch(search) {
      if (!this.serialItem || this.serialFlow !== "out") return;
      this.serialSearch = search || "";
      this.serialPage = 1;
      this.fetchProductSerials(this.serialItem, {
        page: 1,
        search: this.serialSearch,
        append: false,
      });
    },
    loadMoreSerials() {
      if (
        !this.serialItem ||
        this.serialFlow !== "out" ||
        this.serialsLoading ||
        this.serialPage >= this.serialLastPage
      ) {
        return;
      }
      this.fetchProductSerials(this.serialItem, {
        page: this.serialPage + 1,
        search: this.serialSearch,
        append: true,
      });
    },
    mergeSerialOptions(existing, incoming) {
      const next = Array.isArray(existing) ? existing.slice() : [];
      const seen = new Set(next.map((serial) => serial.id).filter((id) => id != null));
      incoming.forEach((serial) => {
        if (serial.id != null && seen.has(serial.id)) return;
        if (serial.id != null) seen.add(serial.id);
        next.push(serial);
      });
      return next;
    },
    selectedSerialRows(item) {
      return this.normalizeArticleSerials(item && item.serials).map((serial) => ({
        ...serial,
        selected: true,
      }));
    },
    fetchProductSerials(item, options = {}) {
      if (!item || !item.product || !item.product.id) {
        this.serialsLoading = false;
        return;
      }
      const page = options.page || 1;
      const search = options.search !== undefined ? options.search : this.serialSearch;
      const append = !!options.append;
      if (append && this.serialsLoading) return;
      const entrepotId = (this.entrepot || {}).id;
      var app = this;
      if (app.serialCancelToken) {
        app.serialCancelToken.cancel("Canceled due to new serial request");
      }
      app.serialCancelToken = app.$axios.CancelToken.source();
      const requestId = ++app.serialRequestId;
      app.serialsLoading = true;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getProductSerials",
            product_id: item.product.id,
            entrepot_id: entrepotId,
            search: search || "",
            page,
          },
          cancelToken: app.serialCancelToken.token,
        })
        .then((res) => {
          if (requestId !== app.serialRequestId || app.serialItem !== item) return;
          const payload = res.data;
          const list = Array.isArray(payload) ? payload : (payload && payload.data) || [];
          app.serialPage =
            (payload &&
              (payload.current_page || (payload.meta && payload.meta.current_page))) ||
            page;
          app.serialLastPage =
            (payload &&
              (payload.last_page || (payload.meta && payload.meta.last_page))) ||
            1;
          const selectedIds = new Set(
            (item.serials || []).map((serial) => serial.id).filter((id) => id != null)
          );
          const selectedValues = new Set(
            (item.serials || []).map((serial) => String(serial.value || "").trim())
          );
          const optionsList = app.normalizeArticleSerials(list).map((serial) => ({
            ...serial,
            selected:
              selectedIds.has(serial.id) ||
              selectedValues.has(String(serial.value || "").trim()),
          }));
          const merged = append
            ? app.mergeSerialOptions(item.serialOptions, optionsList)
            : app.mergeSerialOptions(app.selectedSerialRows(item), optionsList);
          app.$set(item, "serialOptions", merged);
        })
        .catch((err) => {
          if (!app.$axios.isCancel(err)) {
            this.serverErrorHandeler(err);
          }
        })
        .finally(() => {
          if (requestId === app.serialRequestId) {
            app.serialsLoading = false;
          }
        });
    },
    setSerials(serials) {
      if (!this.serialItem) return;
      this.$set(this.serialItem, "serials", serials);
      if (this.serialFlow === "out" && this.serialItem.serialOptions) {
        const selectedIds = new Set(
          (serials || []).map((serial) => serial.id).filter((id) => id != null)
        );
        this.serialItem.serialOptions.forEach((option) => {
          option.selected = selectedIds.has(option.id);
        });
      }
    },
    sanitizeSerialItems(items) {
      return (items || []).map((item) => {
        const next = { ...item };
        delete next._serialProductId;
        delete next.serialOptions;
        next.serial_ids = (item.serials || [])
          .map((serial) => serial && serial.id)
          .filter((id) => id != null);
        delete next.serials;
        return next;
      });
    },
    buildProductionSubmitPayload() {
      const payload = { ...this.$data };
      delete payload.serials;
      delete payload.serial_ids;
      delete payload.serialCancelToken;
      delete payload.serialDialog;
      delete payload.serialItem;
      delete payload.serialsLoading;
      delete payload.serialPage;
      delete payload.serialLastPage;
      delete payload.serialSearch;
      delete payload.serialRequestId;
      delete payload.serialFlowMode;
      delete payload.headerSerialRow;
      payload.items = this.sanitizeSerialItems(this.items);
      payload.serials = this.normalizeArticleSerials(
        this.headerSerialRow && this.headerSerialRow.serials
      );
      return payload;
    },
    create() {
      if (!this.$refs.form.validate()) return false;
      var app = this;
      app.isLoading = true;
      const payload = this.buildProductionSubmitPayload();
      if (app.type == "formula") {
        delete payload.date;
      }
      app.$axios
        .post(this.$endpoint + "production", payload)
        .then((res) => {
          app.snakbarText = app.$t("registered");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.goTo(app.type + "List");
        })
        .catch((err) => {
          if (err.response && err.response.status === 409) {
            this.$store.commit("SET_PLAN_DIALOG", true);
          }
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    update() {
      var app = this;
      app.isLoading = true;
      const payload = this.buildProductionSubmitPayload();
      if (app.type == "formula") {
        delete payload.date;
      }
      app.$axios
        .put(this.$endpoint + "production/" + this.$route.params.id, payload)
        .then((res) => {
          res = res.data;
          app.$emit("close", app.$route);
          app.goTo(app.type + "List");
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "production/" + this.$route.params.id + "/edit", {
          params: {
            id: this.$route.params.id,
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.type = res.type;
            app.id = res.id;
            app.count = res.count;
            app.name = res.name;
            app.branch = res.branch;
            app.entrepot = res.entrepot;
            if (
              res.product &&
              res.product.meta &&
              res.product.meta.has_serial === "active"
            ) {
              app.$set(res.product, "has_serial", "active");
            }
            app.product = res.product;
            app.items = res.article;
            (app.items || []).forEach((item) => app.hydrateItemSerials(item));
            app.headerSerialRow.product = app.product;
            app.headerSerialRow.count = app.count;
            app.$set(
              app.headerSerialRow,
              "serials",
              app.normalizeArticleSerials(
                (res.product && res.product.serials) || res.serials
              )
            );
            if (app.getProductHasSerial(app.product)) {
              app.$set(app.headerSerialRow, "has_serial", "active");
              app.headerSerialRow._serialProductId = app.product.id;
            }
            app.items.forEach((item) => {
              if (item.product && parseFloat(item.count) > 0) {
                app.getCost(item);
              }
            });
            app.date = res.date;
            app.content = res.content;
            app.formula = res.formula;
            app.status = res.last_status ? res.last_status.status : null;
            if (res.tags) {
              app.tag = res.tags;
            }
            // app.render = true
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    clearForm() {
      this.selected = [];
      this.printDialog = false;
      this.deletDialog = false;
      this.showSelect = false;
      this.filter = false;
      this.valid = true;
      this.costItems = null;
      this.detail = null;
      this.recipientEntrepot = null;
      this.relations = null;
      this.productStatus = null;
      this.productStatusItems = null;
      this.entrepot = null;
      this.model = null;
      this.from = 1;
      this.taskDialog = null;
      this.id = null;
      this.status = null;
      this.tag = null;
      this.temp = null;
      this.deleteItem = null;
      this.sellStatus = null;
      this.items = [];
      this.sortBy = [];
      this.dialog = null;
      this.timer = 0;
      this.totalItems = 1000;
      this.isLoading = false;
      this.snakbar = false;
      this.taskId = null;
      this.snakbarText = null;
    },
    remoceCostList(cost) {
      var index = this.costItems.cost.indexOf(cost);
      this.costItems.cost.splice(index, 1);
      this.costListDialog = false;
      this.removeCost([cost]);
    },
    removeCost(cost) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "CostIncome", {
          params: {
            deleteItems: cost,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
        })
        .finally(() => (app.loading = false));
    },
  },
};
</script>

<style scoped></style>
